import React, { FormEvent, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Clear from "@material-ui/icons/Clear";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import { DialogProps } from "./dialogRouter";
import { withNamespaces, WithNamespaces } from "react-i18next";
import http from "../../services/http";
import TextField from "@material-ui/core/TextField";
import {
	FormManager,
	FormControlState,
	createControl,
	DefaultValidators as Validators
} from "../../utils/FormManager";
import { toastMessage } from "../../utils/helpers";
import DotsLoader from "../shared/DotsLoader";
import FadeInLetters from "../shared/FadeInLetters";

const EmailControl = createControl("Email", "@", [Validators.email], true);
const formManager = new FormManager();

export const ShareConfiguration: React.FunctionComponent<
	DialogProps & WithNamespaces
> = ({ title, hideDialog, t }) => {
	const [email, setEmail] = useState<FormControlState>(EmailControl);
	const [error, setError] = useState<boolean>(false);
	const [generating, setGenerating] = useState<boolean>(false);

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (!formManager.formIsValid) {
			formManager.touchControls();
			return;
		}

		setGenerating(true);

		http
			.sendPdfSummary(email.value)
			.then(() => {
				setGenerating(false);
				toastMessage(t("toasts.summarySent"));
				hideDialog();
			})
			.catch(error => {
				setGenerating(false);
				setError(true);
				console.log(`an error occured: ${error}.`);
			});
	};

	// update controls on every render
	formManager.addAllControls([[email, setEmail]]);

	const emailError =
		!email.pristine && !formManager.controlIsValid(EmailControl);

	return (
		<Dialog
			open={true}
			disableBackdropClick={true}
			onClose={hideDialog}
			fullWidth={true}
			maxWidth={"sm"}
			aria-labelledby="export configuration modal"
		>
			<DialogTitle id="setup-parts-dialog-title">
				<Grid container justify="space-between" direction="row">
					<h2 className="setups-headline underline uppercase">
						<FadeInLetters text={title} />
					</h2>
					<IconButton className="dialog-hide-icon" onClick={hideDialog}>
						<Clear />
					</IconButton>
				</Grid>
			</DialogTitle>
			<form noValidate onSubmit={handleSubmit}>
				<DialogContent>
					{error && (
						<p className="error margin-initial">{t("errors.sendingEmail")}</p>
					)}
					<TextField
						autoFocus
						id="email"
						label={t("dialogs.shareConfiguration.sendTo")}
						value={email.value}
						fullWidth={true}
						disabled={generating}
						onChange={({ target: { value } }) => setEmail({ ...email, value })}
						margin="normal"
						required={true}
						error={emailError}
						helperText={emailError ? t("errors.invalidEmail") : ""}
					/>
				</DialogContent>
				<DialogActions>
					<button
						type="submit"
						onClick={handleSubmit}
						disabled={generating}
						className="primary"
					>
						{t(`buttons.${generating ? "generating" : "send"}`)}
						{generating && <DotsLoader></DotsLoader>}
					</button>
				</DialogActions>
			</form>
		</Dialog>
	);
};

export default withNamespaces()(ShareConfiguration);
